/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'people.menu.renotify.flag.description': '我们正在通过电子邮件向所有人发送提醒。此操作最多可能需要一分钟。',
  'people.menu.renotify.flag.description.confluence': '提醒团队成员',
  'people.menu.renotify.flag.title': '正在发送提醒',
  'people.menu.renotify.flag.title.confluence': '正在重新发送邀请电子邮件',
  'people.menu.renotify.menu.description':
    '{userCount, plural, other {{userCount,number} 人尚未接受其 {product} 邀请。查看遗漏人员并向其发送提醒。}}',
  'people.menu.renotify.menu.description.confluence':
    '某些人员尚未接受其 Confluence 邀请。查看遗漏人员并向其发送提醒。',
  'people.menu.renotify.menu.dismiss': '关闭',
  'people.menu.renotify.menu.dismiss.confluence': '以后再说',
  'people.menu.renotify.menu.remind': '提醒团队成员',
  'people.menu.renotify.menu.remind.confluence': '提醒团队成员',
  'people.menu.renotify.menu.title': '大家都加入了吗？',
  'people.menu.renotify.modal.copied': '链接已复制',
  'people.menu.renotify.modal.copy': '复制邀请链接',
  'people.menu.renotify.modal.description': '我们可以通过电子邮件向缺席成员发送提醒，或者您也可以自行共享邀请链接。',
  'people.menu.renotify.modal.description.confluence': '再次发送邀请电子邮件，或者复制并共享邀请链接。',
  'people.menu.renotify.modal.dismiss': '取消',
  'people.menu.renotify.modal.resend': '发送提醒',
  'people.menu.renotify.modal.resend.confluence': '重新发送邀请',
  'people.menu.renotify.modal.title': '提醒缺席成员',
  'people.menu.renotify.modal.title.confluence': '提醒遗漏的团队成员',
  'ptc.pm.collaborators.title': '您的协作者',
  'ptc.pm.error-heading': '出现错误',
  'ptc.pm.error-image-alt-text': '机器人出现故障，有多人正在进行修理。',
  'ptc.pm.error-text': '我们会持续跟踪这些错误，但如果刷新不能解决问题，请随时与我们联系',
  'ptc.pm.num-members': '{memberCount, plural, other {{memberCount,number} 名成员}}',
  'ptc.pm.people': '人员',
  'ptc.pm.teams': '团队',
  'ptc.pm.view-your-profile': '查看您的个人资料',
  'ptc.pm.your-teams.title': '您的团队',
};
